import {Table} from "./Table";
import {getCurrentTurnFromFen} from "../utils/chessFunctions";
import {useEffect, useState} from "react";

const Moves = ({moves, initialFen}) => {
    //Initial fen is used to determine which color started (in custom games or jumpstart chess black might start)

    const [movePairs, setMovePairs] = useState([])

    const convertMovesToPairs = (moves, initialFen) => {
        const startingColor = getCurrentTurnFromFen(initialFen);
        let firstPair = startingColor === "b" ? ["", moves.slice(0, 1)] : moves.slice(0, 2);
        let restPairs = [];

        //A bit hacky, but the length of the first pair tells us how many moves we already included in our pairing, so dont include again
        for (let i = firstPair.length; i < moves.length; i += 2) {
            restPairs.push([moves[i], moves[i + 1]])
        }

        return [firstPair, ...restPairs]
    }

    useEffect(() => {
        setMovePairs(convertMovesToPairs(moves, initialFen))
    }, [moves, initialFen]);

    return (
        <div className="box" style={{display: 'flex', flexDirection: 'column', minWidth: "8rem", height: "100%", overflow: "auto"}}>
            <h4 style={{
                textAlign: 'center',
                marginTop: '0',
                marginBottom: '0rem',
                paddingBottom: '0.5rem',
                borderBottom: '1px solid #000',
            }}>
                Moves
            </h4>
            <div style={{fontSize: '0.9rem'}}>
                {movePairs.map((movePair) => {
                    return <div style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        width: "100%",
                        color: '#666',
                        height: "2rem",
                        borderBottom: '1px solid #eee'
                    }}>
                        <p>{movePair[0]}</p>
                        <p>{movePair[1]}</p>
                    </div>
                })}
            </div>
        </div>)
}

export default Moves;